<script>
import { mapState, mapActions } from "vuex";
import { VueGoodTable } from "vue-good-table";
import APIService from "@/services/api.service";
import axios from "axios";
import config from "@/data/config";
import PaginationCustom from "@/components/pagination";
import { SweetModal } from "sweet-modal-vue";

export default {
	name: "umatData",
	components: {
		VueGoodTable,
		SweetModal,
		PaginationCustom,
	},
	data() {
		return {
			loading: true,
			PDFloading: false,
			frameLoading: false,
			baseURL: config.baseURL,
			windowHeight: window.innerHeight - 250,
			fileURL: "",
			pageLength: 20,
			item: {
				id: "",
				uid: "",
				nama: "",
				jk: "",
				tempatLahir: "",
				tglLahir: "",
				lingkungan_stasi: "",
				alamat: "",
			},
			columns: [
				{
					label: "Nama",
					field: "nama",
					sortable: false,
					thClass: "text-center",
				},
				{
					label: "L/P",
					field: "jk",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
					filterOptions: {
						enabled: true,
						placeholder: "Semua",
						filterDropdownItems: ["L", "P"],
						trigger: "enter",
					},
				},
				{
					label: "TTL",
					field: this.tglLahirFn,
					sortable: false,
					thClass: "text-center",
				},
				{
					label: "Stasi/Lingkungan",
					field: "lingkungan_stasi",
					sortable: false,
					thClass: "text-center",
					filterOptions: {
						enabled: true,
						placeholder: "Semua",
						filterDropdownItems: [
                     "AGUSTINUS",
                     "AMBROSIUS",
                     "ANDREAS",
                     "ANGELA MERICI",
                     "BERNADETA",
                     "BERNARDUS",
                     "BUNDA MARIA",
                     "ELISABET",
                     "FRANSISKUS ASISI",
                     "JERORA I BUNDA MARIA",
                     "JERORA I YOHANES PAULUS II",
                     "JERORA I YOSEF",
                     "JERORA II MARKUS",
                     "JERORA II MATIUS",
                     "JERORA II PETRUS",
                     "LUKAS",
                     "LUSIA",
                     "PAULUS",
                     "THERESIA",
                     "THOMAS RASUL",
                     "YAKOBUS",
                     "YOHANES DON BOSCO",
                     "YOHANES",
                     "YOSEF",
						],
						trigger: "enter",
					},
				},
				{
					label: "Baptis",
					field: "is_baptis",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
					// filterOptions: {
					// 	enabled: true,
					// 	placeholder: "Semua",
					// 	filterDropdownItems: ["Sudah", "Belum"],
					// 	trigger: "enter",
					// },
				},
				{
					label: "Komuni I",
					field: "is_komuni",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "Krisma",
					field: "is_krisma",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "Perkawinan",
					field: "is_perkawinan",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "KK",
					field: "is_kk",
					sortable: false,
					tdClass: "text-center",
					thClass: "text-center",
				},
			],
			rows: [],
			totalRecords: 0,
			serverParams: {
				columnFilters: {},
				sort: {
					field: "",
					type: "",
				},
				search: "",
				page: 1,
				perPage: 20,
			},
		};
	},
	mounted() {
		this.loadItems();
		// console.log(this.auth.group_id)
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			auth: (state) => state.auth.user,
			// totalRecords: (state) => state.keluargaKatolik.totalRecords,
		}),
		getStatus() {
			return (value) =>
				value > 0
					? '<i class="fa fa-check text-success"></i>'
					: '<i class="fa fa-times text-dark"></i>';
		},
	},
	watch: {
		PDFloading: function (val) {
			if (val) {
				this.$swal({ text: "Loading", allowOutsideClick: false });
				this.$swal.showLoading();
			} else {
				this.$swal.close();
			}
		},
	},
	methods: {
		tglLahirFn(row) {
			return (
				row.tempat_lahir +
				", " +
				this.$moment(row.tgl_lahir).format("DD-MM-YYYY")

				// moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
			);
		},
		...mapActions({
			getAll: "umat/getAllRemote",
			delete: "umat/delete",
		}),
		refreshData() {
			this.updateParams({
				perPage: 20,
				page: 1,
				search: { searchTerm: "" },
			});
			this.$refs["goodTable"].reset();
			this.loadItems();
		},
		tambahData() {
			this.$router.push("/umat/add");
		},
		setEdit() {
			this.$router.push("/umat/edit/" + this.item.uid);
		},
		getDetail() {
			this.$router.push("/umat/detail/" + this.item.uid);
		},
		swalConfirm() {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Ya, Hapus!",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					return this.delete(this.item.uid).then(
						(response) => {
							return Promise.resolve(response.data);
						},
						(error) => {
							this.$swal("Gagal!", "", "danger");
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== "undefined") {
					if (result.value) {
						this.loadItems();
						this.$bvModal.hide("modal-action");
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
		showPDFKK() {
			this.PDFloading = true;
			this.frameLoading = true;
			this.fileURL = this.baseURL + "assets/_blank.pdf";
			axios
				.post(APIService.getPDFKK(), this.item, {
					headers: APIService.getHeader(),
				})
				.then(
					(response) => {
						this.fileURL =
							this.baseURL + "pdf/" + response.data.filename + ".pdf";
						this.$refs.modalfile.open();
						this.PDFloading = false;
					},
					() => {
						// this.PDFloading = false;
					}
				);
		},
		load() {
			this.frameLoading = false;
		},

		// --------------------
		// ---- GOOD TABLE ----
		// --------------------
		async loadItems() {
			this.loading = true;
			await this.getAll(this.serverParams).then((response) => {
				// console.log(response);
				this.rows = response.rows;
				this.totalRecords = response.totalRecords;
			});
		},
		updateParams(newProps) {
			this.serverParams = Object.assign({}, this.serverParams, newProps);
		},
		onPageChange(params) {
			this.updateParams({ page: params.currentPage });
			this.loadItems();
		},
		onPerPageChange(params) {
			this.updateParams({ perPage: params.currentPerPage });
			this.loadItems();
		},
		onPageChangePagination(page) {
			this.updateParams({ page: page });
			this.loadItems();
		},
		onPerPageChangePagination(perPage) {
         console.log(perPage)
			this.updateParams({ perPage: perPage });
			this.loadItems();
		},
		onSortChange(params) {
			this.updateParams({
				sort: [
					{
						type: params.sortType,
						field: this.columns[params.columnIndex].field,
					},
				],
			});
			this.loadItems();
		},
		onColumnFilter(params) {
			this.updateParams(params);
			this.loadItems();
		},
		onSearch(params) {
			if (params.searchTerm) {
				this.serverParams.search = params;
				this.serverParams.page = 1;
				this.loadItems();
			}
		},
		onRowClick(params) {
			// console.log(params);
			this.item.id = params.row.id;
			this.item.uid = params.row.uid;
			this.item.nama = params.row.nama;
			this.item.jk = params.row.jk;
			this.item.tempatLahir = params.row.tempat_lahir;
			this.item.tglLahir = this.$moment(params.row.tgl_lahir).format(
				"DD MMMM YYYY"
			);
			this.item.lingkungan_stasi = params.row.lingkungan_stasi;
			this.item.alamat = params.row.alamat;
			this.$bvModal.show("modal-action");
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Data Umat" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh & Reset"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
                           <!-- BYPASS TAMBAH UMAT UNTUK AKUN LINGKUNGAN -->
                           <b-button
                              variant="primary"
                              size="sm"
                              @click="tambahData()"
                              v-b-tooltip.hover
                              title="Tambah"
                              ><i class="fa fa-plus"></i> &nbsp;
                              &nbsp;Tambah</b-button
                           >
									<!-- <b-button
										v-show="this.auth.group_id != '3'"
										variant="primary"
										size="sm"
										@click="tambahData()"
										v-b-tooltip.hover
										title="Tambah"
										><i class="fa fa-plus"></i> &nbsp;
										&nbsp;Tambah</b-button
									> -->
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<vue-good-table
						mode="remote"
						ref="goodTable"
						@on-page-change="onPageChange"
						@on-sort-change="onSortChange"
						@on-column-filter="onColumnFilter"
						@on-per-page-change="onPerPageChange"
						@on-row-click="onRowClick"
						@on-search="onSearch"
						:totalRows="totalRecords"
						:isLoading.sync="loading"
						:pagination-options="{
							enabled: true,
							mode: 'pages',
							dropdownAllowAll: false,
							setCurrentPage: 1,
							perPage: 20,
							ofLabel: 'dari',
							perPageDropdown: [20, 50, 100],
						}"
						:rows="rows"
						:columns="columns"
						:search-options="{
							enabled: true,
							trigger: 'enter',
							placeholder: 'Cari Nama',
						}"
						:line-numbers="true"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'is_baptis'">
								<span v-html="getStatus(props.row.is_baptis)"></span>
								<!-- {{ props.row.is_baptis }} -->
							</span>
							<span v-else-if="props.column.field == 'is_komuni'">
								<span v-html="getStatus(props.row.is_komuni)"></span>
								<!-- {{ props.row.is_komuni }} -->
							</span>
							<span v-else-if="props.column.field == 'is_krisma'">
								<span v-html="getStatus(props.row.is_krisma)"></span>
								<!-- {{ props.row.is_krisma }} -->
							</span>
							<span v-else-if="props.column.field == 'is_perkawinan'">
								<span
									v-html="getStatus(props.row.is_perkawinan)"
								></span>
								<!-- {{ props.row.is_perkawinan }} -->
							</span>
							<span v-else-if="props.column.field == 'is_kematian'">
								<span v-html="getStatus(props.row.is_kematian)"></span>
								<!-- {{ props.row.is_kematian }} -->
							</span>
							<span v-else-if="props.column.field == 'is_kk'">
								<span v-html="getStatus(props.row.is_kk)"></span>
								<!-- {{ props.row.is_kk }} -->
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
						<!-- pagination -->
						<template slot="pagination-bottom" slot-scope="props">
							<pagination-custom
								:total="props.total" 
                        :pageChanged="props.pageChanged"
								:perPageChanged="props.perPageChanged"
                        @update:page="onPageChangePagination"
                        @update:perpage="onPerPageChangePagination"
                        >
							</pagination-custom>
						</template>
					</vue-good-table>
				</div>
			</div>
		</div>

		<b-modal id="modal-action" centered title="Action" hide-footer>
			<div class="card">
				<div class="card-body card-action">
					<div class="collection-filter-block">
						<ul>
							<li>
								<div class="media">
									<div class="media-body">
										<h5>Nama</h5>
										<p>{{ item.nama }}</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<div class="media-body">
										<h5>Tempat/Tanggal Lahir</h5>
										<p>
											{{ item.tempatLahir }}<br />{{ item.tglLahir }}
										</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<div class="media-body">
										<h5>Stasi/Lingkungan</h5>
										<p>{{ item.lingkungan_stasi }}</p>
									</div>
								</div>
							</li>
							<li>
								<div class="media">
									<div class="media-body">
										<h5>Alamat</h5>
										<p>{{ item.alamat }}</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<!-- silde-bar colleps block end here-->
			</div>
			<div class="text-center">
				<b-btn-group class="btn-group-pill text-center">
					<div
						class="btn-download btn btn-gradient f-w-500"
						@click="getDetail()"
					>
						<i class="fa fa-eye"></i><br />Detail
					</div>
               <!-- BYPASS EDIT DATA UMAT OLEH AKUN LINGKUNGAN -->
					<div
						class="btn-download btn btn-gradient f-w-500"
						@click="setEdit()"
					>
						<i class="fa fa-edit"></i><br />Edit
					</div>					
               <!-- <div
						class="btn-download btn btn-gradient f-w-500"
						@click="setEdit()"
						v-show="this.auth.group_id != '3'"
					>
						<i class="fa fa-edit"></i><br />Edit
					</div> -->
					<div
						class="btn-download btn btn-gradient-danger f-w-500"
						@click="swalConfirm()"
						v-if="this.auth.group_id != '3'"
					>
						<i class="fa fa-times"></i><br />Delete
					</div>
				</b-btn-group>
			</div>
		</b-modal>

		<sweet-modal
			modal-theme="light"
			overlay-theme="dark"
			width="80%"
			ref="modalfile"
		>
			<div class="loader-box" v-show="frameLoading">
				<div class="loader-2"></div>
			</div>
			<iframe
				v-show="!frameLoading"
				width="100%"
				:height="windowHeight"
				:src="fileURL"
				frameborder="0"
				allowfullscreen
				@load="load()"
			></iframe>
		</sweet-modal>
	</div>
</template>

<style scoped>
.card-action {
	padding: 10px !important;
}
.btn-gradient-danger {
	color: #fff !important;
	font-weight: 500;
	padding: 10px 30px;
	border-radius: 5px;
	background: linear-gradient(26deg, #ff2828 0%, #ff7878 100%);
	letter-spacing: 0.06rem;
}
.btn-gradient-danger:hover {
	background: linear-gradient(26deg, #ff0000 0%, #ff4e4e 100%);
}
.btn-gradient:hover {
	background: linear-gradient(26deg, var(--theme-deafult) 0%, #7b29ff 100%);
}
</style>